/**
 * ============================================================================
 * TaskFlow ERP
 * Module : Campaign Management
 * Feature: Prospect Import
 *
 * File:
 * src/modules/campaign/prospectImport/services/campaignImportService.js
 *
 * Description:
 * Service layer for Prospect Import.
 *
 * Currently this service returns Mock Data.
 *
 * Later only this file will be changed to call Backend APIs.
 * Pages and Components should never call Mock Data directly.
 * ============================================================================
 */

import {
    verifyResponseMock,
    uploadResponseMock,
    importDetailsMock,
    campaignImportMockResponse,
    compareProspectMock,
    editableProspectMock,
    importProgressMock
} from "../mock/campaignImportMock";

import {
    campaignCompareMockResponse
} from "../mock/campaignCompareMock";

import {
    campaignTemplateMockResponse,
    downloadTemplateResponseMock
} from "../mock/campaignTemplateMock";

/**
 * Small delay to simulate API response.
 */
const delay = (ms = 500) =>
    new Promise(resolve => setTimeout(resolve, ms));

/**
 * ============================================================================
 * Campaign Import Service
 * ============================================================================
 */

const campaignImportService = {

    /**
     * ------------------------------------------------------------------------
     * Download Import Template
     * ------------------------------------------------------------------------
     */
    async downloadTemplate() {

        await delay();

        return {
            success: true,
            data: downloadTemplateResponseMock
        };
    },

    /**
     * ------------------------------------------------------------------------
     * Verify Uploaded File
     * ------------------------------------------------------------------------
     */
    async verifyFile(file) {

        console.log("Mock Verify File :", file);

        await delay(1000);

        return {
            success: true,
            data: verifyResponseMock
        };
    },

    /**
     * ------------------------------------------------------------------------
     * Upload Import File
     * ------------------------------------------------------------------------
     */
    async uploadImport(file) {

        console.log("Mock Upload :", file);

        await delay(1200);

        return {
            success: true,
            data: uploadResponseMock
        };
    },

    /**
     * ------------------------------------------------------------------------
     * Get Import List
     * ------------------------------------------------------------------------
     */
    async getImportList() {

        await delay();

        return {
            success: true,
            data: campaignImportMockResponse
        };
    },

    /**
     * ------------------------------------------------------------------------
     * Get Import Details
     * ------------------------------------------------------------------------
     */
    async getImportDetails(importId) {

        console.log("Mock Import Details :", importId);

        await delay();

        return {
            success: true,
            data: importDetailsMock
        };
    },

    /**
     * ------------------------------------------------------------------------
     * Compare Prospect
     * ------------------------------------------------------------------------
     */
    async compareProspect(recordId) {

        console.log("Mock Compare :", recordId);

        await delay();

        return {
            success: true,
            data: campaignCompareMockResponse
        };
    },

    /**
     * ------------------------------------------------------------------------
     * Update Imported Prospect
     * ------------------------------------------------------------------------
     */
    async updateImportedProspect(recordId, payload) {

        console.log("Mock Update :", recordId);

        console.log(payload);

        await delay();

        return {
            success: true,
            message: "Prospect updated successfully.",
            data: {
                ...editableProspectMock,
                ...payload
            }
        };
    },

    /**
     * ------------------------------------------------------------------------
     * Finalize Import
     * ------------------------------------------------------------------------
     */
    async finalizeImport() {

        await delay(1500);

        return {
            success: true,
            message: "Prospects imported successfully."
        };
    },

    /**
     * ------------------------------------------------------------------------
     * Import Progress
     * ------------------------------------------------------------------------
     */
    async getImportProgress() {

        await delay();

        return {
            success: true,
            data: importProgressMock
        };
    },

    /**
     * ------------------------------------------------------------------------
     * Template Information
     * ------------------------------------------------------------------------
     */
    async getTemplateInfo() {

        await delay();

        return {
            success: true,
            data: campaignTemplateMockResponse
        };
    }

};

export default campaignImportService;